import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { IHomePageBetterForEveryone } from '../interfaces/IHomePageBetterForEveryone';

const ABOUT_PAGE_BETTER_FOR_EVERYONE: IHomePageBetterForEveryone[] = [
  {
    id: 1,
    description:
      'Visualize your project, collaborate on the plan and know the costs, all before you get started.',
    title: 'Homeowners',
    titleColor: 'brandGreen.500',
    linkTitle: 'Design here',
    responsiveLinkTitle: 'Read more',
    linkTo: '/how-it-works',
    image: (
      <StaticImage
        placeholder="blurred"
        alt="home page homeowners"
        src="../assets/images/home_page_owners.png"
        quality={100}
      />
    ),
  },
  {
    id: 2,
    description:
      'Get measurements, complete estimates and order materials, all in one place.',
    title: 'Pros',
    linkTitle: 'Build here',
    titleColor: 'brandOrange.500',
    linkTo: '/exterior-contractors',
    image: (
      <StaticImage
        placeholder="blurred"
        alt="home page pros"
        src="../assets/images/home_page_pros.png"
        quality={100}
      />
    ),
  },
  {
    id: 3,
    description:
      'A quicker claims process makes one of the hardest things anyone goes through a little bit easier.',
    title: 'Insurance',
    linkTitle: 'The process',
    titleColor: 'brown.500',
    linkTo: '/insurance',
    image: (
      <StaticImage
        placeholder="blurred"
        alt="home page insurance"
        src="../assets/images/home_page_insurance.png"
        quality={100}
      />
    ),
  },
  {
    id: 4,
    description:
      'Spend less time taking and filling orders and more time building relationships.',
    title: 'Distributors',
    linkTitle: 'Meet our partners',
    linkTo: '/partners',
    nativeLink: true,
    titleColor: 'brandNavy.500',
    image: (
      <StaticImage
        placeholder="blurred"
        alt="home page distributors"
        src="../assets/images/home_page_distributors.png"
        quality={100}
      />
    ),
  },
];

export default ABOUT_PAGE_BETTER_FOR_EVERYONE;
